// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"7e7e9516","42":"ac17a412","89":"3b06c350","150":"e4488378","174":"3a6f71b0","336":"9ec1d9c9","488":"370c36c9","560":"cfcfc31f","598":"0efbe1c5","904":"3a80af6d","954":"c35bef94"}[chunkId] + ".chunk.js";
};